<template>
  <div class="defaultViewStyle">
    <list-page>
      <page-header />
      <table-list>
        <el-descriptions :column="3" border>
          <el-descriptions-item label="仓库名称">
            <el-input v-model="dataDetail.stockName" />
          </el-descriptions-item>
          <el-descriptions-item label="所属部门" v-if="needDepart">
            <el-tree-select v-model="dataDetail.bankupId" :data="departList"  check-strictly :render-after-expand="false" placeholder="请选择所在部门" :props="{children: 'children', label: 'departName'}" node-key="id"/>
          </el-descriptions-item>
          <el-descriptions-item label="仓库地址">
            <el-input v-model="dataDetail.stockAddress" />
          </el-descriptions-item>
          <el-descriptions-item label="坐标踩点">
            <span v-if="dataDetail.lng">
              {{dataDetail.lng + "," + dataDetail.lat}}
            </span>
          </el-descriptions-item>
        </el-descriptions>
        <!-- 地图 -->
        <tx-map map-id="stockDetailMap" @getLocation="mapGetLocation" :address="dataDetail.stockAddress" :lat="dataDetail.lat" :lng="dataDetail.lng" style="height: 100%" />
      </table-list>
      <form-page :show-page="false">
        <page-button el-type="primary" type="write" @click="saveData">
          保存
        </page-button>
      </form-page>
    </list-page>
  </div>
</template>
<script setup>
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableList from "@/components/h5/layout/TableList.vue";
import PageHeader from "@/components/h5/layout/PageHeader.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import {reactive, ref, getCurrentInstance, onMounted} from "vue"
import commonApi from "@/api/commonApi";
import stockApi from "@/api/main/stock/stockApi";
import TxMap from "@/components/h5/map/TxMap.vue";

const {proxy} = getCurrentInstance()

const dataDetail = ref({});
const needDepart = ref(false)
const departList = ref([])

const saveData = async () => {
  stockApi.save(dataDetail.value).then(data => {
    dataDetail.value = data
  })
}

const mapGetLocation = (location) => {
  dataDetail.value.lng = location.lng;
  dataDetail.value.lat = location.lat;
  dataDetail.value.stockAddress = location.address;
}

// 初始化部门
const initDepart = () => {
  commonApi.findSetting("STOCK_BANKUP").then(data => {
    needDepart.value = data.settingValue === "1";
    if (needDepart.value) {
      // 查询部门
      stockApi.queryDepartListTree().then(list => departList.value = list);
    }
  });
}

onMounted(() => {
  if (proxy.$routerUtil.query.id) {
    stockApi.findById(proxy.$routerUtil.query.id).then(data => {
      console.log(data)
      dataDetail.value = data
    })
  }
})

initDepart()
</script>